import * as actions from './getTodoActions';

const getTodoReducer = {
  [actions.USER_GET_TODO_ITEMS_SUCCESS_RECEIVED]: (
    state,
    { payload: todo }
  ) => {
    return { ...state, todo };
  },
};

export default getTodoReducer;
